// import link from '@/public/link.js'

// 用户中心
const loginUrl = process.env.VUE_APP_PERSONURL
const materialUrl = process.env.VUE_APP_MATERIALSURL
function materialsShopUrl (companyNo,tabType) {
  if(tabType){
    window.open(materialUrl+'/company?no='+companyNo+'&type='+tabType, "_blank")
  }else{
    window.open(materialUrl+'/company?no='+companyNo, "_blank")
  }
}
function login () {
  window.open(
    `${loginUrl}/login`, '_blank'
  )
}
function sign () {
  window.location.href = loginUrl + '/sign'
}

function personal () {
  console.log(loginUrl)
  window.open(loginUrl)
}
// 机械出租
function editRent () {
  window.location.href = loginUrl + '/editRent'
}
// 机械求租
function editInquiry () {
  window.location.href = loginUrl + '/editInquiry'
}
// 认证中心 AC(authentication center)
function AC () {
  window.location.href = loginUrl + '/authenticationManagement'
}
// 我的消息
function myMessage () {
  window.location.href = loginUrl + '/myMessage'
}
// 我的简历
function personnelreleaseaddFun () {
  window.open(
    `${loginUrl}/personnelreleaseadd`, '_blank'
  )
}
// 工程材料
// const materialsUrl = process.env.VUE_APP_MATERIALSURL
const materialsUrl = process.env.VUE_APP_HOME
// 首页
function index () {
  window.location.href = materialsUrl
}
// 采购订单
function myOrder () {
  window.location.href = loginUrl + '/myOrder'
}
// 招标发布
function tendering () {
  window.location.href = loginUrl + '/tendering'
}
// 查询报价
function purchaserofferrecord () {
  window.location.href = loginUrl + '/purchaserofferrecord'
}
// 预算邀请报价
function offerlist () {
  window.location.href = loginUrl + '/offerlist'
}
// 销售订单
function MySalesOrder () {
  window.location.href = loginUrl + '/MySalesOrder'
}
// 商品发布
function addCommodity () {
  window.location.href = loginUrl + '/addCommodity'
}
// 商机查询
function businessquery () {
  window.location.href = loginUrl + '/businessquery'
}
// 投标记录
function mybidding () {
  window.location.href = loginUrl + '/mybidding'
}
// 报价查询
function offerrecord () {
  window.location.href = loginUrl + '/offerrecord'
}
// 机械发布
function myRent () {
  window.location.href = loginUrl + '/myRent'
}
// 设备发布
function equipmentRental () {
  window.location.href = loginUrl + '/equipmentRental'
}

const link = {
  personnelreleaseaddFun,
  login,
  sign,
  personal,
  editRent,
  editInquiry,
  AC,
  myMessage,
  index,
  myOrder,
  tendering,
  purchaserofferrecord,
  offerlist,
  MySalesOrder,
  addCommodity,
  businessquery,
  mybidding,
  offerrecord,
  myRent,
  equipmentRental,
  materialsShopUrl
}
export default link
